import { RouteObject } from 'react-router-dom'
import { NotesPage } from './notes'

export const NotesRoute: RouteObject = {
    path: '/notes',
    element: <NotesPage />,
}
